import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { showNotification } from '@mantine/notifications';
import { authorizedGet } from '../../fetchFunctions';
import { Loader } from '@mantine/core';
import { formateExactDate } from '../../utils';
import { downloadInvoicePdf } from './pdfDownload';

const documentLabel = (invoice) =>
	invoice?.ksefNumber || invoice?.insideId || invoice?.externalInvoiceNumber || '';

const Recipes = () => {
	const [searchInvoice, setSearchInvoice] = useState('');

	const [sortBy, setSortBy] = useState('number');
	const [numberAsc, setNumberAsc] = useState(true);
	const [dateAsc, setDateAsc] = useState(false);

	const { data: purchases, isLoading } = useQuery(['purchases'], () =>
		authorizedGet(`/purchase_invoices?pagination=${false}`)
	);

	const invoices = Array.isArray(purchases)
		? purchases
		: purchases?.['hydra:member'] ?? [];

	const sortRecipes = (a, b) => {
		if (sortBy === 'number') {
			return numberAsc
				? documentLabel(a).localeCompare(documentLabel(b))
				: documentLabel(b).localeCompare(documentLabel(a));
		}
		if (sortBy === 'date') {
			return dateAsc
				? new Date(a.createdAt) - new Date(b.createdAt)
				: new Date(b.createdAt) - new Date(a.createdAt);
		}
	};

	const download = async (invoice) => {
		const saved = await downloadInvoicePdf(invoice);
		if (saved) return;

		showNotification({
			message: 'Nie udało się pobrać dokumentu PDF.',
			color: 'red',
		});
	};

	return (
		<div className="white-box white-box--library">
			<div className="white-box__inner">
				<div className="invoices">
					<div className="invoices__head-wrapper">
						<div className="invoices__head-left">
							<h2 className="main-title main-title--25">Dokumenty księgowe</h2>
							<div className="main-text wysiwyg">
								<p>
									Poniżej znajdują się dokumenty wystawione do Twoich pobrań.
								</p>
							</div>
						</div>

						<div className="invoices__head-right">
							<div className="form js-validate">
								<div className="input-wrapper">
									<input
										value={searchInvoice}
										onChange={(e) => setSearchInvoice(e.target.value)}
										type="text"
										name="f-search"
										placeholder="Numer dokumentu"
										className="form__input search-input required"
									/>
									<button type="submit">
										<i className="ico ico-search-icon"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
					{isLoading && <Loader />}
					{!isLoading && invoices.length === 0 && (
						<div className="invoices-table-container">
							<span className="btn btn--sort desc">
								<span>Brak dokumentów księgowych....</span>
							</span>
						</div>
					)}
					{!isLoading && invoices?.length > 0 && (
						<div className="invoices-table-container">
							<table className="invoices-table">
								<thead>
									<tr className="filters">
										<th className="th-document">
											<button
												onClick={() => {
													setNumberAsc((prevState) => !prevState);
													setSortBy('number');
												}}
												className={`btn btn--sort ${
													numberAsc ? 'desc' : 'asc'
												}`}
											>
												<span>NR DOKUMENTU</span>
												<i className="ico ico ico-chevron-thin-down"></i>
											</button>
										</th>
										<th className="th-date">
											<button
												onClick={() => {
													setDateAsc((prevState) => !prevState);
													setSortBy('date');
												}}
												className={`btn btn--sort ${dateAsc ? 'desc' : 'asc'}`}
											>
												<span>Data wystawienia</span>
												<i className="ico ico ico-chevron-thin-down"></i>
											</button>
										</th>
										<th className="th-action"></th>
									</tr>
								</thead>
								<tbody>
									{invoices
										?.filter((i) => {
											return documentLabel(i)
												.toLocaleLowerCase()
												.includes(searchInvoice.toLocaleLowerCase());
										})
										?.sort(sortRecipes)
										?.map((invoice) => {
											const pdfUrl =
												invoice.generatedPDF || invoice.fakturomatPdfUrl;
											return (
												<tr key={invoice.id}>
													<td className="td-document">
														<span className="invoices-table__rwd-label">
															Nr dokumentu
														</span>
														{documentLabel(invoice) || '-'}
													</td>
													<td className="td-date">
														<span className="invoices-table__rwd-label">
															Data wystawienia
														</span>
														{formateExactDate(invoice?.createdAt)}
													</td>
													<td className="td-action">
														{pdfUrl ? (
															<span
																style={{ cursor: 'pointer' }}
																onClick={() => download(invoice)}
																className="invoices__download"
															>
																<i className="ico ico-download-icon"></i>
																<span>Pobierz</span>
															</span>
														) : (
															<span>Brak pliku</span>
														)}
													</td>
												</tr>
											);
										})}
								</tbody>
							</table>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Recipes;
